
export default class AcumulatorBonusModel {
  /**
   * class constructor method
   * @param data
   */
  constructor(data) {
    /**
     * Id of the accumulator rule
     * @type {number}
     */
    this.accumulatorRuleID = data.AccumulatorRuleID;
    /**
     * Bonus percentage for this rule
     * @type {number}
     */
    this.bonusPercentage = data.BonusPercentage;
    /**
     * Brand Id
     * @type {number}
     */
    this.brandID = data.BrandID;
    /**
     * Id of the bonus
     * @type {number}
     */
    this.id = data.ID;
    /**
     * Minimum odd for this rule
     * @type {number}
     */
    this.minOdd = data.MinOdd;
    /**
     * Minimum number of selections for this rule
     * @type {number}
     */
    this.minSelections = data.MinSelections;
    /**
     * Flag wheather to include stake in bonus calculation
     * @type {boolean}
     */
    this.bonusOnPotentialWinningAmount = data.BonusOnPotentialWinningAmount || false;
  }
}
